export const PRIVACY_POLICY_URL = 'https://tinuiti.com/privacy-policy/';

// The AG-UI frontend tool the combined agent chat offers. The client acts on it, so it's never shown.
export const HANDOFF_TOOL_NAME = 'handoff';

export const Feedback = {
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE'
} as const;
export type FeedbackType = (typeof Feedback)[keyof typeof Feedback];

export const NEGATIVE_FEEDBACK_OPTIONS = [
  'The data is wrong or incomplete.',
  "The answer doesn't address my specific question.",
  'Other'
];

// CSV attachments, offered only by hosts that opt in (AgentChat's allowCsvAttachment). The cap
// matches the incrementality agent's own limit.
export const CSV_ATTACHMENT_ACCEPT = '.csv,text/csv';
export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024;
